/** @jsx jsx */
import { Text, jsx } from 'theme-ui'
import { string } from 'prop-types'
import React from 'react'

const Heading = ({ headline, subtitle }) => {
  return (
    <React.Fragment>
      <Text variant="h3" as="h3" sx={{ mb: subtitle ? 4 : 7 }}>
        {headline}
      </Text>
      {subtitle && (
        <Text variant="smallText" color="darkGray" sx={{ mb: 7 }}>
          {subtitle}
        </Text>
      )}
    </React.Fragment>
  )
}
Heading.propTypes = {
  headline: string.isRequired,
  subtitle: string,
}
export default Heading
